<form (submit)="search()" class="rn-search-input">
  <input type="text" placeholder="search" name="search" [(ngModel)]="searchString">
  <button type="submit"><i class="fa fa-search"></i></button>
</form>
